//2021-10-29

import alerts from 'alerts-promise';
import progress from 'progress';

class Overlays
{
	static createLoadingOverlay(autoOpen, message)
	{	//2015-12-16 //2022-04-07
		if(typeof autoOpen === 'undefined') autoOpen = true;
		
		const overlay = alerts.createOverlay(autoOpen);
		
		if(typeof message !== 'undefined')
		{
			const messageWrapper = document.createElement('div');
			messageWrapper.classList.add('messageWrapper');
			
			const messageDiv = document.createElement('div');
			messageDiv.innerHTML = message;
			
			messageWrapper.appendChild(messageDiv);
			overlay.overlay.appendChild(messageWrapper);
		}
		
		const loading = document.createElement('div');
		loading.classList.add('fa', 'fa-circle-o-notch', 'fa-spin', 'loading');
		
		overlay.overlay.appendChild(loading);
		
		return overlay;
	}
	
	static createProgressOverlay(autoOpen)
	{	//2018-04-24 //2022-04-07
		if(typeof autoOpen === 'undefined') autoOpen = true;
		
		const overlay = alerts.createOverlay(autoOpen);
		
		const pb = progress.ProgressBar();
		const pc = pb.getContainer();
		
		overlay.setProgress = percentage => pb.setProgress(percentage);
		
		const progressBar = document.createElement('div');
		progressBar.classList.add('progress');
		
		progressBar.appendChild(pc);
		
		overlay.overlay.appendChild(progressBar);
		
		return overlay;
	}
	
	static activeToolTipMessage = null;
	static createToolTipIcon(containerElement, type, message)
	{	//2015-11-24
		const typeData =
		{
			help:'fa-question-circle',
			info:'fa-info-circle',
			warning:'fa-exclamation-circle'
		};
		
		const icon = typeData[type] || typeData['help'];
		
		var messageCallback = message;
		if(typeof(messageCallback) !== 'function') messageCallback = () => message;
		
		const toolTipIcon = document.createElement('span');
		toolTipIcon.classList.add('toolTipIcon', 'fa', icon);
		
		containerElement.appendChild(toolTipIcon);
		
		const duration = 120;
		
		toolTipIcon.messageActive = false;
		toolTipIcon.messageObject = null;
		
		const mouseover = event =>
		{
			if(toolTipIcon.messageActive) return;
			
			toolTipIcon.messageActive = true;
			
			if(Overlays.activeToolTipMessage)
			{
				Overlays.activeToolTipMessage.remove();
				Overlays.activeToolTipMessage = null;
			}
			
			const toolTipMessage = document.createElement('div');
			toolTipMessage.classList.add('toolTipMessage');
			toolTipMessage.style.display = 'none';
			
			let messageText = messageCallback();
			
			if(messageText === '') return;
			
			messageText = messageText.replace(/\r\n/g, '<br />');
			messageText = messageText.replace(/\n/g, '<br />');
			messageText = messageText.replace(/\r/g, '<br />');
			
			// toolTipMessage.textContent = messageText;
			toolTipMessage.innerHTML = messageText; // For some reason we are using html in these...
			
			toolTipMessage.addEventListener('mouseover', mouseover);
			toolTipMessage.addEventListener('mouseout', mouseout);
			
			Overlays.activeToolTipMessage = toolTipMessage;
			toolTipIcon.messageObject = toolTipMessage;
			
			toolTipIcon.appendChild(toolTipMessage);
			
			// toolTipMessage.fadeIn(duration);
			toolTipMessage.classList.add('shown');
			toolTipMessage.style.display = '';
			
			const toolTipBox = toolTipMessage.getBoundingClientRect();

			// Check for overflow on the right side
			if((toolTipBox.left + toolTipBox.width) > window.innerWidth)
			{
				toolTipMessage.style.left = -((toolTipBox.left + toolTipBox.width) - window.innerWidth) + 'px';
			}
			// Check for overflow on the bottom side
			if ((toolTipBox.top + toolTipBox.height) > window.innerHeight) {
				toolTipMessage.style.top = -((toolTipBox.top + toolTipBox.height * 2) - window.innerHeight) + 'px';
			}
		};
		
		const mouseout = event =>
		{
			toolTipIcon.messageActive = false;
			
			setTimeout(() =>
			{
				if(!toolTipIcon.messageActive) toolTipIcon.messageObject.remove();
			}, 1000);
		};
		
		toolTipIcon.addEventListener('mouseover', mouseover);
		toolTipIcon.addEventListener('mouseout', mouseout);
		
		return toolTipIcon;
	}
	
	static initializeToolTips(element)
	{// 2022-08-25
		const helpToolTips = element.querySelectorAll('[data-help],[data-info],[data-warning]');
		const toolTips = [];
		for(const helpToolTip of helpToolTips)
		{
			let type = helpToolTip.dataset.tipType || null
			
			if(type === null)
			{
				if(!!helpToolTip.dataset.help) type = 'help';
				if(!!helpToolTip.dataset.info) type = 'info';
				if(!!helpToolTip.dataset.warning) type = 'warning';
			}
			
			const toolTip = Overlays.createToolTipIcon(helpToolTip, type || 'help', () => helpToolTip.dataset[type || 'help']);
			
			toolTips.push(toolTip);
		}
		
		return toolTips;
	}
};

export default Overlays;
